<template>
 
<div>
  
  <div>


          <v-row  dense class="text-center">  

 <v-col  cols="12">
           <MusePlayer :videoOptions="videoOptions" @play="handlePlay" @pause="handlePause" ref="musePlayer" />
 
 </v-col>

                  <v-col  cols="1">
                    <v-card-actions>
                        <v-spacer></v-spacer>   
                      <v-btn color="pink darken-2" outlined @click="playVideo">Play</v-btn>
                      <v-spacer></v-spacer>                  
                    </v-card-actions>         
                  </v-col>
                  <v-col  cols="1">
                    <v-card-actions class="mt-6">
                      <v-spacer></v-spacer>
                        <v-btn color="pink darken-2" outlined @click="pauseVideo">Pause</v-btn>
                        <v-spacer></v-spacer>                  
                      </v-card-actions>
                  </v-col>
                  <v-col  cols="1">
                    <v-card-actions class="mt-6">
                      <v-spacer></v-spacer>
                        <v-btn color="pink darken-2" outlined @click="changeVideo">Change</v-btn>
                        <v-spacer></v-spacer>                  
                      </v-card-actions>
                  </v-col>        
                  <v-col  cols="9">
                  </v-col>                                                
                </v-row>

  </div>
</div>
</template>

<style>
.v-progress-circular {
margin: 1rem;
}
</style>



<script>

import MusePlayer from '@/components/MusePlayer.vue';


export default {

  name: 'CheckVideos',
  components: {
    MusePlayer
  },
  data: () => ({

    videoPointer: 0,

    videos: ['J2c1U6d', 'dDXztqP', 'xF92Jic', 'ccLfReF', 'dDweXH564XztqP'],
    videoOptions: {
        video: null,
        width: '550px',
        style: 'no-controls'
      }  
 
  }),   

  created() {
      this.videoOptions.video = this.videos[0];

  },   
  methods: {

    handlePlay() {
      console.log('Play event triggered');
      // Handle play event
      // Perform any actions you want when the play event occurs
    },
    handlePause() {
      console.log('Pause event triggered');
      // Handle pause event
      // Perform any actions you want when the pause event occurs
    },
    playVideo() {
      console.log("playVideo")
      this.$refs.musePlayer.player.play();
    },
    pauseVideo() {
      console.log("pauseVideo")
      this.$refs.musePlayer.player.pause();
    },
    changeVideo() {


      console.log(this.videoPointer)
      if (this.videoPointer<this.videos.length - 1) {
        this.videoPointer++
      } else {
        this.videoPointer=0
      }

      this.$refs.musePlayer.player.setVideo(this.videos[this.videoPointer])
      //this.videoOptions.video=this.videos[this.videoPointer]

      
    }  
  }          
}
</script>
